import { useMemo } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { MODEL_METADATA_SHAPE, COMPOSITION_VISIBILITY_SHAPE } from "connected-components/asset-view/prop-types"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { useSourceTemplateMetricIds } from "connected-components/asset-view/hooks/use-source-displayed-metrics"
import { useAssetViewData } from "connected-components/asset-view/hooks/use-asset-view-data"
import { useAssetViewTemplateChart } from "../../hooks/use-asset-view-template-chart"
import { ASSET_VIEW_FACTOR_SENSITIVITY_CHART } from "../template-chart-config"

export default function FactorSensitivityHeader({ modelMetadata, flattenedMetrics, onMetricsChange, compositionVisibility }) {
  const { selectedMetricDisplay, setSelectedMetricDisplay, selectedCategory, setSelectedCategory } = useAssetViewTemplateChart(ASSET_VIEW_FACTOR_SENSITIVITY_CHART)
  const { view } = useAssetViewData()

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const metricOptions = useMemo(
    () => ({ prefix: view, selectedCategory, selectedMetricDisplay }),
    [view, selectedCategory, selectedMetricDisplay],
  )

  useSourceTemplateMetricIds({ flattenedMetrics, onMetricsChange, metricOptions, compositionVisibility })

  const displayOptions = useMemo(() => METRIC_OPTIONS.factorSensitivity.map(({ id, label, isDefault, secondaryText, tooltip }) => ({ id, primaryText: label, isDefault, secondaryText, tooltip })), [])

  const categoryOptions = useMemo(() => modelMetadata.categories.map(({ id, label }) => ({ id, primaryText: label })), [modelMetadata])

  return <>
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
    />
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

FactorSensitivityHeader.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  flattenedMetrics: PropTypes.object,
  onMetricsChange: PropTypes.func,
  compositionVisibility: COMPOSITION_VISIBILITY_SHAPE,
}
